import About from "./About";
import Contact from "./Contact";
import Projects from "./Projects";

const Home = () => {
    return ( 
        <div>
            <About/>
            <Projects/> 
            <Contact/>
        </div>
     );
}
 
export default Home;